import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Router} from '@angular/router';
import {PaymentData} from 'src/app/models/application/payment-data.model';
import {DialogService} from 'src/app/services/dialog.service';
import {SessionService} from 'src/app/services/session.service';
import {Constants} from '../../common/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Meta, Title} from '@angular/platform-browser';

@Component({
    selector: 'app-fad-personal',
    templateUrl: './fad-personal.component.html',
    styleUrls: ['./fad-personal.component.scss']
})
export class FadPersonalComponent implements AfterViewInit, OnInit {
    private userData: any;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    countryVisit: any = false;
    contactForm: any;
    constructor(
        private sessionService: SessionService,
        private router: Router,
        private dialogService: DialogService,
        private deviceService: DeviceDetectorService,
        private metas: Meta,
        private titlePage: Title
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        const TITLE = 'Compre um plano de assinatura digital pessoal | A única Assinatura Autógrafa Digital®';
        const DESCRIPTION = 'Pacotes e assinaturas a partir de $ 9.90 USD de assinatura digital, o único processo patenteado com 100% de validade legal, comprovado em julgamentos, fácil e simples de usar.';
        const URL = 'https://www.assinaturaautografadigital.com.br/assinatura-digital-para-pessoas';
        const IMG = 'https://hola.firmaautografa.com/hubfs/BRASIL-ASSETS/METAS-PLACE-BRASIL-PAGES/personal.png';
        this.titlePage.setTitle(TITLE);
        /* PRINCIPALES */
        this.metas.updateTag({
            name: 'keywords',
            content: 'firma digital de documentos, como realizar la firma digital de documentos'
        });
        this.metas.updateTag({
            name: 'description',
            content: DESCRIPTION
        });
        /* FACEBOOK Y LINKEDIN */
        this.metas.updateTag({
            property: 'og:url',
            content: URL
        });
        this.metas.updateTag({
            property: 'og:title',
            content: TITLE
        });
        this.metas.updateTag({
            property: 'og:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            property: 'og:image',
            content: IMG
        });
        /* TWITTER */
        this.metas.updateTag({
            name: 'twitter:title',
            content: TITLE
        });
        this.metas.updateTag({
            name: 'twitter:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            name: 'twitter:image',
            content: IMG
        });
        /* LOCALIZACION */
        this.sessionService.getLocationUser().subscribe(
            (response: any) => {
                if (response) {
                    this.sessionService.getCountrieUser(response.location.lat, response.location.lng).subscribe(
                        (responseCountrie: any) => {
                            this.sessionService.setCountryData(responseCountrie.results[responseCountrie.results.length - 2]
                                .formatted_address);
                            this.countryVisit = this.sessionService.getCountryData() === 'México';
                        }
                    );
                }
            }
        );
        window.scrollTo(0, 0);
        this.userData = this.sessionService.getPaymentAccount();
    }

    ngAfterViewInit(): void {
    }

    callForm(type, isAdd?: boolean): void {
        let data: PaymentData;
        switch (type) {
            case 1:
                data = {
                    product: 'FAD® PESSOAL',
                    subscription: 'Plano mensal',
                    type: 'month',
                    quantity: 1,
                    usuarios: 1,
                    usuariosLabel: 'Usuário incluído',
                    /* En lugar de mandar el mensaje de ilimitadas, cambie el texto por 1000*/
                    transactions: '1000',
                    transactionType: 'Vídeo de aceitação do acordo + Vídeo assinatura + Constância de conservação',
                    pricing: 59.90,
                    pricingInfo: 'R',
                    complements: [...Constants.defaultComplementsP]
                };
                this.addDataLayerPersonal(data);
                break;
            case 2:
                data = {
                    product: 'FAD® PESSOAL',
                    subscription: 'Pré-pago com validade anual',
                    type: 'anual',
                    quantity: 1,
                    usuarios: 1,
                    usuariosLabel: 'Usuário incluído',
                    transactions: '10',
                    transactionType: 'Vídeo de aceitação do acordo + Vídeo assinatura + Constância de conservação',
                    pricing: 59.90,
                    pricingInfo: 'R',
                    complements: [...Constants.defaultComplementsP]
                };
                this.addDataLayerPersonal(data);
                break;
            case 6:
                this.contactForm = 6;
                if (this.isMobile === true || this.isTablet === true) {
                    document.querySelector('#contact-cotizar-movil').scrollIntoView();
                } else {
                    document.querySelector('#contact-cotizar').scrollIntoView();
                }
                break;
            case 7:
                this.contactForm = 7;
                if (this.isMobile === true || this.isTablet === true) {
                    document.querySelector('#contact-cotizar-movil').scrollIntoView();
                } else {
                    document.querySelector('#contact-cotizar').scrollIntoView();
                }
                break;   

        }
        if (this.userData === null) {
            /*
            if (isAdd) {
                this.sessionService.updateCartList(data, true);
            } else {
                const itemExist = this.sessionService.getCartItems().find(
                    item => item.product === data.product && item.subscription === data.subscription
                );
                if (itemExist) {
                    this.sessionService.setPaymentData(data);
                    this.router.navigate(['/comprar-assinatura-digital']);
                } else {
                    if (this.sessionService.getCartItems().length === 0) {
                        this.sessionService.updateCartList(data, true);
                        this.sessionService.setPaymentData(data);
                        this.router.navigate(['/comprar-assinatura-digital']);
                    } else {
                        this.dialogService.showNotificationDialog('Ups!', ' Você não pode combinar pacotes.');
                    }
                }
            }*/
        } else {
            if (this.userData.isCompany === false) {
                if (isAdd) {
                    this.sessionService.updateCartList(data, true);
                } else {
                    const itemExist = this.sessionService.getCartItems().find(
                        item => item.product === data.product && item.subscription === data.subscription
                    );
                    if (itemExist) {
                        this.sessionService.setPaymentData(data);
                        this.router.navigate(['/comprar-assinatura-digital']);
                    } else {
                        if (this.sessionService.getCartItems().length === 0) {
                            this.sessionService.updateCartList(data, true);
                            this.sessionService.setPaymentData(data);
                            this.router.navigate(['/comprar-assinatura-digital']);
                        } else {
                            this.dialogService.showNotificationDialog('Ups!', ' Você não pode combinar pacotes.');
                        }
                    }
                }
            } else {
               // this.dialogService.showNotificationDialog('Sua conta é empresarial', 'Você não pode adicionar este produto, você precisa de uma conta pessoal.');
            }
        }
    }

    ngOnInit(): void {
        this.addDataLayer();
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            ecommerce: {
                currencyCode: 'BRL',
                impressions: [
                    {
                        name: 'FAD® - Plano Pessoal - Plano Mensal',
                        id: 'FADPPSM',
                        price: '59,90',
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Assinaturas Ilimitadas',
                        list: 'FAD® Assinatura - Plano Pessoal',
                        position: 1
                    },
                    {
                        name: 'FAD® - Plano Pessoal - Pré-pago anual',
                        id: 'FADPPPA10',
                        price: '59.90',
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Anual 10',
                        list: 'FAD® Assinatura - Plano Pessoal',
                        position: 2
                    },
                    {
                        name: 'FAD® - Plano Pessoal - Pré-pago anual',
                        id: 'FADPPPA20',
                        price: '99.90',
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Anual 20',
                        list: 'FAD® Assinatura - Plano Pessoal',
                        position: 3
                    },
                    {
                        name: 'FAD® - Plano Pessoal - Pré-pago anual',
                        id: 'FADPPPA50',
                        price: '249.90',
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Anual 50',
                        list: 'FAD® Assinatura - Plano Pessoal',
                        position: 4
                    },
                    {
                        name: 'FAD® - Plano Pessoal - Pré-pago anual',
                        id: 'FADPPPA100',
                        price: '449.90',
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Anual 100',
                        list: 'FAD® Assinatura - Plano Pessoal',
                        position: 5
                    },
                    {
                        name: 'FAD® - Plano Pessoal - Pré-pago anual',
                        id: 'FADPPPA200',
                        price: '799.90',
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Anual 200',
                        list: 'FAD® Assinatura - Plano Pessoal',
                        position: 6
                    },
                    {
                        name: 'FAD® - Plano Pessoal - Pré-pago anual',
                        id: 'FADPPPA500',
                        price: '1,899.90',
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Anual 500',
                        list: 'FAD® Assinatura - Plano Pessoal',
                        position: 8
                    },
                    {
                        name: 'FAD® - Plano Pessoal - Pré-pago anual',
                        id: 'FADPPPA10000',
                        price: '3,499.90',
                        brand: 'FAD®',
                        category: 'FAD® Pessoal',
                        variant: 'Anual 1000',
                        list: 'FAD® Assinatura - Plano Pessoal',
                        position: 9
                    }
                ]
            }
        });
    }

    addDataLayerPersonal(item: any): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        if (item.type === 'month') {
            // @ts-ignore
            dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: 'BRL',
                    add: {                                // 'add' actionFieldObject measures.
                        products: [{                        //  adding a product to a shopping cart.
                            name: 'FAD® - Plano Pessoal - Plano Mensal',
                            id: 'FADPPSM',
                            price: '59,90',
                            brand: 'FAD®',
                            category: 'FAD® Pessoal',
                            variant: 'Assinaturas Ilimitadas',
                            position: 1
                        }]
                    }
                }
            });
        } else {
            // @ts-ignore
            dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: 'BRL',
                    add: {                                // 'add' actionFieldObject measures.
                        products: [{                        //  adding a product to a shopping cart.
                            name: 'FAD® - Plano Pessoal - Pré-pago anual',                    // Name or ID is required.
                            id: 'FADPPPA' + item.transactions,
                            price: item.pricing,
                            brand: 'FAD®',
                            category: 'FAD® Pessoal',
                            variant: 'Anual ' + item.transactions,
                            position: 2
                        }]
                    }
                }
            });
        }
    }
}
